import { gql } from "@apollo/client"

const SIGN_IN = gql`
  mutation SignIn($email: String!, $password: String!) {
    signIn(email: $email, password: $password) {
      message
      currentUser {
        graphqlUserType
      }
    }
  }
`

const CREATE_SUBSCRIPTION = gql`
  mutation CreateSubscription($subscription: JSON!) {
    createSubscription(subscription: $subscription) {
      message
    }
  }
`

export { SIGN_IN, CREATE_SUBSCRIPTION }
